import React from "react";
import { CardContent, Typography } from "@mui/material";

interface Article {
  title: string;
  link: string;
  pubDate: string;
  description: string;
  imageUrl: string;
}

interface ArticleCardProps {
  article: Article;
}

export const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => (
  <div className="p-2 h-full">
    <div className="border rounded-lg flex flex-col h-full overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 bg-white">
      <div className="w-full aspect-video overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <CardContent className="flex flex-col flex-grow p-4">
        <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
          {article.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" className="flex-grow mb-4">
          {`${article.description.slice(0, 120)}...`}
        </Typography>
        <a
          href={article.link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline mt-auto self-start font-semibold"
        >
          Read more
        </a>
      </CardContent>
    </div>
  </div>
);